module.exports = __webpack_public_path__ + "img/team-worked-4.89b93149.png";